import axios from '../utils/request';

export const getUserDetail = () => axios.get('/user');

export const getUserShare = () => axios.get('/distribution_img');

export const getUserRebateList = ({ page } = {}) =>
  axios.get('/fl', { params: { page } });

export const createWithdrawDetail = ({ money } = {}) =>
  axios.post('/tx', { money });

export const getOrders = ({ page = 1, status }) =>
  axios.get('/code', {
    params: {
      page,
      status,
    },
  });

export const createOrder = ({
  id,
  tel,
  uid,
  shop,
  date,
  info,
  count,
  shape,
  // eslint-disable-next-line camelcase
  ticket_type,
  agentId,
  // eslint-disable-next-line camelcase
  coupon_id,
  // eslint-disable-next-line camelcase
  tour_guide_id,
}) =>
  axios.post('/order', {
    tel,
    uid,
    info,
    shape,
    ticket_type,
    cid: id,
    use_date: date,
    totalNum: count,
    channel_id: shop,
    agent_id: agentId,
    coupon_id,
    tour_guide_id,
  });

export const updateOrder = ({ orderid, paychannel }) =>
  axios.post('/pay', { orderid, paychannel });

export const createRefund = ({ code }) =>
  axios.post('/refund', {
    code,
  });

export const getUserOpenid = () => axios.get('/getopenid');

export const getUserAgencyStatus = ({ openid } = {}) =>
  axios.post('/gettravel', { openid });

export const createRechargeDetail = ({ money }) =>
  axios.post('/memberpay', { price: money });

export const getRechargeList = ({ page } = {}) =>
  axios.get('/payrecord', { params: { page } });

export const getConsumeList = ({ page } = {}) =>
  axios.get('/credit2', { params: { page } });

export const createUserDetail = ({ tel } = {}) =>
  axios.post('/user', {
    tel,
  });

export const updateUserDetail = ({ tel, gameNickName } = {}) =>
  axios.put('/user', {
    tel,
    game_name: gameNickName,
  });

export const getBalanceList = ({ page } = {}) =>
  axios.get('/credit2', { params: { page } });

export const getIntegralList = ({ page } = {}) =>
  axios.get('/credit1', { params: { page } });

export const getHoursList = ({ page } = {}) =>
  axios.get('/credit3', { params: { page } });

export const getParticipationList = ({ page }) =>
  axios.get('/match', { params: { page } });

export const getHoursRebateList = ({ page }) =>
  axios.get('/fanli', { params: { page } });

export const createBonusOrder = ({
  id,
  tel,
  uid,
  shop,
  date,
  info,
  count,
  shape,
  freeId,
  // eslint-disable-next-line camelcase
  ticket_type,
}) =>
  axios.post('/freecardo', {
    tel,
    uid,
    info,
    shape,
    cid: id,
    use_date: date,
    totalNum: count,
    channel_id: shop,
    free_id: freeId,
    ticket_type,
  });

// 打开储物柜
export const openTheLocker = (mac, spotId) =>
  axios.post('/box/', `spot_id=${spotId}&mac=${mac}`);
// 代理商
export const userInAgent = () => axios.get('/agent');
export const submitUserInAgent = data => axios.post('/agent', data);
